import React from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';
import { selectGspConfig } from 'core/selectors/services';
import MultipleMerchantsItem from '../MultipleMerchantsItem/MultipleMerchantsItem';
import MultipleMerchantsItemGSP from '../MultipleMerchantsItemGSP/MultipleMerchantsItemGSP';
import './MultipleMerchantsList.scss';

function MultipleMerchantsList({ merchants, config }) {
  const gspConfig = useSelector(selectGspConfig);
  const MultipleMerchantsItemComponent = gspConfig.isEnabled ? MultipleMerchantsItemGSP : MultipleMerchantsItem;
  if (!merchants.length) {
    return null;
  }

  return (
    <div className="mn_merchantsList">
      {merchants.map(merchant => (
        <MultipleMerchantsItemComponent key={merchant.id} merchant={merchant} config={config} />
      ))}
    </div>
  );
}

MultipleMerchantsList.propTypes = {
  merchants: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  config: PropTypes.shape({}),
};

MultipleMerchantsList.defaultProps = {
  config: {},
};

export default MultipleMerchantsList;
